import { type EvidenceDetail, EvidenceDetailResults, useApiEvidenceV1EvidenceSessionRetrieve } from 'api';
import { Box, CenteredLoader, DataGrid, EvidenceImage, type GridRowSelectionModel } from 'ui';

const getEvidenceImageVariant = (results: EvidenceDetailResults): 'success' | 'warning' => {
  if (results === null) {
    return 'warning';
  }

  if ('error' in results) {
    return 'warning';
  }

  if (
    'outputs' in results &&
    Array.isArray(results.outputs) &&
    'image_rejected' in results.outputs[0] &&
    results.outputs[0].image_rejected === true
  ) {
    return 'warning';
  }

  return 'success';
};

export const EvidenceGrid = ({
  date,
  uploadedById,
  parentContentTypeId,
  parentId,
  placeholderSrc,
  setSelectedEvidenceIds,
}: {
  date: string;
  uploadedById: number | null;
  parentContentTypeId: number;
  parentId: number;
  placeholderSrc?: string;
  setSelectedEvidenceIds: (ids: number[]) => void;
}) => {
  const { data, isLoading } = useApiEvidenceV1EvidenceSessionRetrieve({
    date,
    parent_content_type_id: parentContentTypeId,
    parent_id: parentId,
    uploaded_by: uploadedById,
  });

  if (isLoading || !data) {
    return <CenteredLoader />;
  }

  return (
    <DataGrid<EvidenceDetail>
      hideFooter
      checkboxSelection
      disableColumnMenu
      onRowSelectionModelChange={(rowSelectionModel: GridRowSelectionModel) => {
        setSelectedEvidenceIds(rowSelectionModel.map((id) => (typeof id === 'string' ? Number.parseInt(id, 10) : id)));
      }}
      rowHeight={250}
      rows={data.evidence_list}
      columns={[
        {
          columnSize: 'large',
          field: 'file_url',
          headerName: 'Evidence',
          renderCell: (params) => {
            return (
              <Box width="250px" position="absolute">
                <EvidenceImage
                  src={params.value}
                  loading="lazy"
                  placeholderSrc={placeholderSrc}
                  slotProps={{
                    resultIcon: {
                      variant: getEvidenceImageVariant(params.row.results),
                    },
                  }}
                />
              </Box>
            );
          },
        },
      ]}
    />
  );
};
